import React, { useState, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Breadcrumb from "../../components/Breadcrumb";
import emailjs from "@emailjs/browser";
import { useLocation, useNavigate } from "react-router-dom";

const JobDetailsMain = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { title, description, responsibilities } = location.state || {};  

  const formRef = useRef();

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
    resume: null,
  });

  if (!title || !description) {
    return (
      <div className="p-4 text-red-600">
        <p>No job data provided. Redirecting...</p>
        {setTimeout(() => navigate("/"), 3000)}
      </div>
    );
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.match(/(pdf|msword|officedocument)/)) {
      setFormData((prev) => ({ ...prev, resume: file }));
      toast.success("Resume file selected");
    } else {
      setFormData((prev) => ({ ...prev, resume: null }));
      toast.error("Please upload a valid PDF or Word file");
    }
  };

  const validateForm = () => {
    const { name, phone, email, resume } = formData;
    if (!name || !phone || !email || !resume) {
      toast.warning("Please fill all required fields and upload a resume");
      return false;
    }
    const phoneRegex = /^[0-9]{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!phoneRegex.test(phone)) {
      toast.error("Enter a valid 10-digit phone number");
      return false;
    }
    if (!emailRegex.test(email)) {
      toast.error("Enter a valid email address");
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const userId = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    const form = formRef.current;
    emailjs
      .sendForm(serviceId, templateId, form, userId)
      .then(() => {
        toast.success("Application sent successfully!");
        setFormData({
          name: "",
          phone: "",
          email: "",
          message: "",
          resume: null,
        });
        form.reset();
        // Clear file input manually
        document.getElementById("resume").value = "";
        console.log("SUCCESS!");
      })
      .catch((error) => {
        toast.error("Failed to send application. Try again.");
        console.error(error);
      });
  };

  return (
    <main>
      <Breadcrumb pageTitle="Job Details" />

      <div className="job-details__area job-details__mlr pt-110 pb-80">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-7 col-lg-7">
              <div
                className="job-details__item wow animate__fadeInUp"
                data-wow-duration="1.1s"
              >
                <div className="job-details__author-info pb-25">
                  <h5>{title}</h5>
                </div>
                <div
                  className="job-details__list pb-30 wow animate__fadeInUp"
                  data-wow-duration="1.1s"
                >
                  <span>About the Role:</span>
                  <p>
                    {description}
                  </p>

                  {responsibilities && responsibilities.length > 0 && (
                    <>
                      <ul>
                        {responsibilities.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>
                    </>
                  )}
                </div>
                <div
                  className="job-details__summary pb-40 wow animate__fadeInUp"
                  data-wow-duration="1.1s"
                >
                  <h4>Job Summary:</h4>
                  <ul>
                    <li>
                      <div className="job-details__content d-flex align-items-center">
                        <div className="job-details__icon">
                          <i className="fas fa-map-marker-alt"></i>
                        </div>
                        <div className="job-details__text">
                          <span>Location</span>
                          <i>Remote - WFH</i>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="job-details__content d-flex align-items-center">
                        <div className="job-details__icon">
                          <i className="fas fa-briefcase"></i>
                        </div>
                        <div className="job-details__text">
                          <span>Job Type</span>
                          <i>Full Time</i>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="job-details__content d-flex align-items-center">
                        <div className="job-details__icon">
                          <i className="far fa-pencil-alt"></i>
                        </div>
                        <div className="job-details__text">
                          <span>Experience </span>
                          <i>Fresher</i>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="job-details__content d-flex align-items-center">
                        <div className="job-details__icon">
                          <i className="fas fa-building"></i>
                        </div>
                        <div className="job-details__text">
                          <span>Qualification</span>
                          <i>Any Degree</i>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className="col-xl-5 col-lg-5 job-right-box wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <h5 className="font-bold mb-4">
                If intrested, please fill out the form below
              </h5>
              <form ref={formRef} onSubmit={handleSubmit} className="space-y-4">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="postbox__contact-input">
                      <input
                        type="text"
                        placeholder="Your Name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-sm-12">
                    <div className="postbox__contact-input">
                      <input
                        type="tel"
                        name="phone"
                        placeholder="Your Phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-sm-12">
                    <div className="postbox__contact-input">
                      <input
                        type="email"
                        name="email"
                        placeholder="Your Email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-sm-12">
                    <div className="mb-30">
                      <input
                        type="file"
                        id="resume"
                        accept=".pdf,.doc,.docx"
                        onChange={handleFileChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-sm-12">
                    <div className="postbox__contact-textarea mb-30">
                      <textarea
                        placeholder="Message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-sm-12">
                    <div className="postbox__submit-btn">
                      <button className="w-100 it-btn">Apply Now</button>
                    </div>
                  </div>
                </div>
              </form>
              {/* Toast Container */}
              <ToastContainer position="top-center" autoClose={3000} />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default JobDetailsMain;
